"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sw_1 = require("firebase/messaging/sw");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const store_1 = require("./src/app-reduxs/store");
const constants_1 = __importStar(require("./src/constants/constants"));
const AppContainer_1 = __importDefault(require("./src/navigators/AppContainer"));
const apis_1 = require("./src/networking/apis");
const scale_1 = require("./src/utils/scale");
const syncStorage_1 = require("./src/utils/syncStorage");
const config_1 = require("./web/firebase/config");
const FirebaseMessaging = () => {
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const [isSupport, setSupport] = (0, react_1.useState)(false);
    const shouldTryAgain = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        (0, sw_1.isSupported)()
            .then((res) => {
            if (res) {
                setSupport(true);
                navigator.serviceWorker.addEventListener('message', (event) => {
                    if (!event.data.action) {
                        return;
                    }
                    switch (event.data.action) {
                        case constants_1.listenerEvents.ON_NOTIFICATION_CLICK:
                            window.location.href = event.data.url;
                            break;
                    }
                });
            }
        })
            .catch(err => {
            console.log('ERROR', err);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (!!myProfile?.registration_status && isSupport) {
            requestMessagingPermission();
        }
    }, [myProfile, isSupport]);
    const getFirebaseMessagingToken = () => {
        config_1.firebase.messaging()
            .getToken({ vapidKey: process.env.MESSAGING_PUBLIC_KEY })
            .then(async (currentToken) => {
            if (currentToken) {
                const oldToken = await (0, syncStorage_1.asyncStorageGetItem)(constants_1.default.FIREBASE_MESSAGING_TOKEN);
                if (currentToken == oldToken)
                    return;
                apis_1.CommonApi.registerDeviceToken({
                    old_token: oldToken || '',
                    platform: react_native_1.Platform.select({
                        android: 1,
                        ios: 2,
                        web: 3,
                        default: 3
                    }),
                    token: currentToken,
                    user_id: myProfile?.user_id
                })
                    .then(() => {
                    (0, syncStorage_1.asyncStorageSetItem)(constants_1.default.FIREBASE_MESSAGING_TOKEN, currentToken);
                })
                    .catch(err => {
                    console.log(err);
                });
            }
        }).catch((err) => {
            if (!shouldTryAgain.current)
                return;
            shouldTryAgain.current = false;
            setTimeout(() => {
                getFirebaseMessagingToken();
            }, 2000);
            console.log('CATCH', err);
        });
    };
    const requestMessagingPermission = () => {
        Notification.requestPermission()
            .then((permission) => {
            if (permission === 'granted') {
                getFirebaseMessagingToken();
            }
        })
            .catch(error => {
            console.log('REQUEST_PERMISSION', error);
        });
    };
    return null;
};
const App = () => {
    return react_native_1.Platform.OS === 'web' ? (react_1.default.createElement(react_native_1.View, { style: { width: scale_1.width, alignSelf: 'center' } },
        react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
            react_1.default.createElement(react_native_1.StatusBar, { barStyle: 'dark-content', backgroundColor: 'transparent', translucent: true }),
            react_1.default.createElement(react_native_safe_area_context_1.SafeAreaProvider, null,
                react_1.default.createElement(react_native_safe_area_context_1.SafeAreaView, null,
                    react_1.default.createElement(react_native_1.View, { style: styles.container },
                        react_1.default.createElement(AppContainer_1.default, null),
                        react_1.default.createElement(FirebaseMessaging, null))))))) : (react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
        react_1.default.createElement(react_native_1.StatusBar, { barStyle: 'dark-content', backgroundColor: 'transparent', translucent: true }),
        react_1.default.createElement(react_native_safe_area_context_1.SafeAreaProvider, null,
            react_1.default.createElement(react_native_safe_area_context_1.SafeAreaView, { edges: [] },
                react_1.default.createElement(react_native_1.View, { style: styles.container },
                    react_1.default.createElement(AppContainer_1.default, null))))));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        height: scale_1.height,
    },
    center: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
exports.default = App;
